import React from "react";
import logo from "../assets/logo.png";

function Navbar() {
  return (
    <nav className="bg-gradient-to-r from-gray-700 to-gray-900 p-4">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-white text-lg font-bold">
          <img src={logo} alt="Logo" width="200" height="200" />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
